import {XHTTP} from '@/shared/xhttp';
import {DevisService} from "@/xhttp/DevisService";
import {Client} from "@/models/Client";
import {DateHelper} from "@/shared/utils";
import {DevisElementsList} from "@/models/DevisElementsList";

@XHTTP(DevisService, '/devis')
export class Devis {

	private _id: number;
	private _name: string;
	private _reference: string;
	private _status: string;
	private _date: Date = new Date();
	private _endOfValidity: Date = new Date();
	private _termsOfPayment: string;
	private _methodOfPayment: string;
	private _amount: number;
	private _amountVAT: number;
	private _amountVATDetailed: [];
	private _marges: [];
	private _amountTotal: number;
	private _devisElementsList: DevisElementsList;
	private _client: Client;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get name(): string {
		return this._name;
	}

	public get reference(): string {
		return this._reference;
	}

	public get status(): string {
		return this._status;
	}

	public get date(): Date {
		return this._date;
	}

	public get endOfValidity(): Date {
		return this._endOfValidity;
	}

	public get termsOfPayment(): string {
		return this._termsOfPayment;
	}

	public get methodOfPayment(): string {
		return this._methodOfPayment;
	}

	public get amount(): number {
		return this._amount;
	}

	public get amountVAT(): number {
		return this._amountVAT;
	}

	public get amountVATDetailed(): [] {
		return this._amountVATDetailed;
	}

	public get marges(): [] {
		return this._marges;
	}

	public get amountTotal(): number {
		return this._amountTotal;
	}

	public get devisElementsList(): DevisElementsList {
		return this._devisElementsList;
	}

	public get client(): Client {
		return this._client;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set name(value: string) {
		this._name = value;
	}

	public set reference(value: string) {
		this._reference = value;
	}

	public set status(value: string) {
		this._status = value;
	}

	public set date(value: Date) {
		this._date = value;
	}

	public set endOfValidity(value: Date) {
		this._endOfValidity = value;
	}

	public set termsOfPayment(value: string) {
		this._termsOfPayment = value;
	}

	public set methodOfPayment(value: string) {
		this._methodOfPayment = value;
	}

	public set amount(value: number) {
		this._amount = value;
	}

	public set amountVAT(value: number) {
		this._amountVAT = value;
	}

	public set amountTotal(value: number) {
		this._amountTotal = value;
	}

	public set devisElementsList(value: DevisElementsList) {
		this._devisElementsList = value;
	}

	public set client(value: Client) {
		this._client = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id       : this._id,
			name     : this._name,
			reference     : this._reference,
			status  : this._status,
			date    : this._date ? DateHelper.toLocalizedStringWithTimeZero(this._date) : null,
			endOfValidity    : this._endOfValidity ? DateHelper.toLocalizedStringWithTimeZero(this._endOfValidity) : null,
			termsOfPayment  : this._termsOfPayment,
			methodOfPayment  : this._methodOfPayment,
			amount  : this._amount ? this._amount : 0,
			amountVAT  : this._amountVAT ? this._amountVAT : 0,
			amountTotal  : this._amountTotal ? this._amountTotal : 0,
			devisElementsList  : this._devisElementsList ? this._devisElementsList.id : null,
			client  : this._client ? this._client.id : null,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._name      = data.name;
		this._reference      = data.reference;
		this._status   = data.status;
		this._date         = data.date ? DateHelper.fromLocalizedString(data.date) : null;
		this._endOfValidity         = data.endOfValidity ? DateHelper.fromLocalizedString(data.endOfValidity) : null;
		this._termsOfPayment   = data.termsOfPayment;
		this._methodOfPayment   = data.methodOfPayment;
		this._amount   = data.amount;
		this._amountVAT   = data.amountVAT;
		this._amountVATDetailed   = data.amountVATDetailed.filter(value => value.montant > 0);
		this._marges   = data.marges.filter(value => value.marges > 0);
		this._amountTotal   = data.amountTotal;
		this._devisElementsList    = data.devisElementsList ? (new DevisElementsList()).fromJSON(data.devisElementsList) : null;
		this._client    = data.client ? (new Client()).fromJSON(data.client) : null;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}